import React, { useEffect, useState } from "react";

// core components
import db from "../../db";
import WhiteNavbar from "../../components/Navbars/WhiteNavbar";
import ContactUs from "../../components/Admin/ContactUs/ContactUs"

// ReactStrap
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Modal,
} from "reactstrap";
import Select from "react-select"
import { LoadingScreen } from "components/MiscFunctions";

export default function AdminContactUs() {
  const [contacts, setContacts] = useState([]);
  const [contactId, setContactId] = useState('')
  const [repName, setRepName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [location, setLocation] = useState("");
  const [opening, setOpening] = useState("");
  const [isDisplayed, setIsDisplayed] = useState(false)

  // Max number of contacts
  const [maxCount] = useState(5)

  useEffect(() => db.Contacts.listenAll(setContacts), []);

  const [smallAlert, setSmallAlert] = useState(false)

  const reset = () => {
    setContactId('')
    setRepName('')
    setEmail('')
    setPhone('')
    setLocation('')
    setOpening('')
  }

  const valid = () =>
    repName &&
    email &&
    phone &&
    location &&
    opening &&
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)

  const validEdit = () =>
    contactId &&
    valid()

  const select = (contactId) => {
    let data = contacts.find((contact) => contact.id === contactId)
    setContactId(data.id)
    setRepName(data.repName)
    setEmail(data.email)
    setPhone(data.phone)
    setLocation(data.location)
    setOpening(data.opening)
  }

  const del = () => {
    db.Contacts.remove(contactId)
    reset()
  }

  const edit = () => {
    db.Contacts.update({ id: contactId, repName, email, phone, location, opening, isDisplayed })
    reset()
  }

  const create = () => {
    db.Contacts.create({ repName, email, phone, location, opening, isDisplayed })
    reset()
  }

  return (
    <>
      {
        !contacts || (contacts && contacts.length > 0) ?
          <>
            <WhiteNavbar />
            <div className="fullBg section-dark">
              <div className="section section-dark">
                <Container>
                  <Row>
                    <Col className="ml-auto mr-auto text-center" md="8">
                      <h2 className="title">Edit Contact Us</h2>
                    </Col>
                  </Row>
                  <Row>
                    {/* Form Starts here */}
                    {
                      // If no contacts, or contact length < max, or contact Id is present, meaning a contact is being edited
                      (!contacts || (contacts && contacts.length < maxCount) || contactId) &&
                      <Col md="6">
                        <Card className="card-contact card-raised">
                          <CardHeader className="header-raised header-primary text-center">
                            <CardTitle tag="h4">Contact Us</CardTitle>
                          </CardHeader>
                          <Form id="contact-form2" method="post" role="form">
                            <CardBody>
                              <Row>
                                <Col md="6">
                                  <FormGroup>
                                    <label className="control-label">Representative Name</label>
                                    <Input
                                      name="name"
                                      placeholder="Representative Name"
                                      type="text"
                                      onChange={(e) => setRepName(e.target.value)}
                                      value={repName}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md="6">
                                  <FormGroup>
                                    <label className="control-label">Email address</label>
                                    <Input
                                      name="email"
                                      placeholder="Email"
                                      type="email"
                                      onChange={(e) => setEmail(e.target.value)}
                                      value={email}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col md="12">
                                  <FormGroup>
                                    <label className="control-label">Phone Number</label>
                                    <Input
                                      name="phone"
                                      placeholder="Phone Number"
                                      type="text"
                                      onChange={(e) => setPhone(e.target.value)}
                                      value={phone}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col md="12">
                                  <FormGroup>
                                    <label className="control-label">Location</label>
                                    <Input
                                      name="location"
                                      placeholder="Location"
                                      type="text"
                                      onChange={(e) => setLocation(e.target.value)}
                                      value={location}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <FormGroup>
                                <label className="control-label">Opening Times</label>
                                <Input
                                  name="opening"
                                  placeholder="Opening Times"
                                  type="text"
                                  onChange={(e) => setOpening(e.target.value)}
                                  value={opening}
                                />
                              </FormGroup>
                              <Row>
                                <Col md="12">
                                  <FormGroup>
                                    <label className="control-label">Display this Contact?</label>
                                    <Select
                                      className="react-select react-select-default border-input"
                                      name="category"
                                      value={isDisplayed}
                                      onChange={(value) => setIsDisplayed(value.value)}
                                      options={[{ value: true, label: "TRUE" }, { value: false, label: "FALSE" }]}
                                      placeholder={isDisplayed.toString().toLocaleUpperCase() || "Display Event?"}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <div className="media-footer">
                                <Row>
                                  <Col lg="8" xs="6" md="8">
                                    {
                                      // Limit the number of contacts to create
                                      !contactId && (contacts === null || (contacts && contacts.length < maxCount)) ?
                                        <Button
                                          className="btn-round mr-1"
                                          color="success"
                                          type="button"
                                          onClick={(e) => {
                                            e.preventDefault()
                                            create()
                                          }}
                                          disabled={!valid()}
                                          style={{ minWidth: "100%" }}
                                        >
                                          Create
                                </Button>
                                        :
                                        <Button
                                          className="btn-round mr-1"
                                          color="success"
                                          type="button"
                                          onClick={(e) => {
                                            e.preventDefault()
                                            edit()
                                          }}
                                          disabled={!validEdit()}
                                          style={{ minWidth: "100%" }}
                                        >
                                          Edit
                                </Button>
                                    }
                                  </Col>
                                  <Col lg="4" xs="6" md="4">
                                    <Button
                                      className="btn-round mr-1"
                                      color="danger"
                                      type="button"
                                      onClick={reset}
                                      style={{ minWidth: "100%" }}
                                    >
                                      Cancel
                            </Button>
                                  </Col>
                                </Row>
                              </div>
                            </CardBody>
                          </Form>
                        </Card>
                      </Col>
                    }
                    {/* Form ends here */}
                    {
                      contacts && contacts.map((contact) =>
                        <ContactUs
                          key={contact.id}
                          {...contact}
                          setContactId={setContactId}
                          select={select}
                          setSmallAlert={setSmallAlert}
                        />
                      )
                    }
                  </Row>
                </Container>

              </div>
            </div>
          </>
          :
          <LoadingScreen />
      }
      {/* modals */}
      <Modal
        size="sm"
        isOpen={smallAlert}
        toggle={() => setSmallAlert(false)}
      >
        <div className="modal-header no-border-header">
          <button
            className="close"
            type="button"
            onClick={() => setSmallAlert(false)}
          >
            ×
        </button>
        </div>
        <div className="modal-body text-center">
          <h5 style={{ fontWeight: "400" }}>Confirm Delete</h5>
        </div>
        <div className="modal-footer">
          <div className="left-side">
            <Button
              className="btn-link"
              color="default"
              type="button"
              onClick={() => {
                setSmallAlert(false)
                reset()
              }}
            >
              Never mind
            </Button>
          </div>
          <div className="divider" />
          <div className="right-side">
            <Button
              className="btn-link"
              color="danger"
              type="button"
              onClick={() => {
                del()
                setSmallAlert(false)
              }}>
              Yes
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
